import {
  Stack,
  FormControlLabel,
  Typography,
  Input,
  SxProps,
} from "@mui/material";
import { ChangeEvent, ReactNode } from "react";

export interface ColorPickerProps {
  label: string;
  color: string;
  setColor: (color: string) => void;
  sx?: SxProps;
  disabled?: boolean;
}

const ColorPicker = ({
  color,
  setColor,
  label,
  sx,
  disabled,
}: ColorPickerProps): ReactNode => {
  const handleChange = (e: ChangeEvent<HTMLInputElement>) => {
    setColor(e.target.value);
  };

  return (
    <Stack direction={"column"} spacing={0}>
      <FormControlLabel
        sx={sx}
        label={<Typography variant="subtitle2">{label}</Typography>}
        labelPlacement={"end"}
        control={
          <Input
            type={"color"}
            value={color}
            onChange={handleChange}
            disabled={disabled}
            disableUnderline
            sx={{ width: 80, mx: 2 }}
            inputProps={{ "aria-label": "color" }}
          />
        }
      />
    </Stack>
  );
};

export default ColorPicker;
